import "./AdminAddService.scss"
import ServiceForm from "./Components/ServiceForm"

export default function AdminAddService() {
  return <ServiceForm/>
}
